import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import {
  contractingActivityKeys,
  contractingKeys,
  contractingNoteKeys,
} from "@/lib/query-keys";

/** Lo que hay que refrescar tras tocar un comentario: la lista, el historial y el badge. */
function useNoteInvalidation() {
  const qc = useQueryClient();
  return (contractingId: number) => {
    qc.invalidateQueries({
      queryKey: contractingNoteKeys.byContracting(contractingId),
    });
    qc.invalidateQueries({
      queryKey: contractingActivityKeys.timeline(contractingId),
    });
    qc.invalidateQueries({ queryKey: contractingKeys.lists() });
  };
}

export function useCreateContractingNote() {
  const invalidate = useNoteInvalidation();
  return useMutation({
    mutationFn: (vars: { contracting_id: number; body: string }) =>
      fetchToBackend("/contractingnotes", {
        method: "POST",
        body: JSON.stringify(vars),
      }),
    onSuccess: (_d, vars) => invalidate(vars.contracting_id),
  });
}

export function useUpdateContractingNote() {
  const invalidate = useNoteInvalidation();
  return useMutation({
    mutationFn: (vars: { id: number; contracting_id: number; body: string }) =>
      fetchToBackend(`/contractingnotes/${vars.id}`, {
        method: "PUT",
        body: JSON.stringify({ body: vars.body }),
      }),
    onSuccess: (_d, vars) => invalidate(vars.contracting_id),
  });
}

export function useDeleteContractingNote() {
  const invalidate = useNoteInvalidation();
  return useMutation({
    mutationFn: (vars: { id: number; contracting_id: number }) =>
      fetchToBackend(`/contractingnotes/${vars.id}`, { method: "DELETE" }),
    onSuccess: (_d, vars) => invalidate(vars.contracting_id),
  });
}
